module.exports = __webpack_public_path__ + "static/media/CEDS UI.027b7447.jpg";